export const iconFontAwesomeMoneyMoneyBillTransfer = (
	<i className="fa-solid fa-money-bill-transfer"></i>
);
